import {
    BrowserIcon,
    CardsIcon,
    CubeIcon,
    GearIcon,
    ShapesIcon,
} from '@phosphor-icons/react/dist/ssr';

import type { IntegrationSideContentTemplateProps } from '@/components/templates/IntegrationSideContentTemplate';

export type IntegrationMenuSelectConfigType = {
    id: string;
    name: string;
    href: string;
};

export const INTEGRATION_MENU_SELECT_CONFIG_MOBILE: IntegrationMenuSelectConfigType[] =
    [
        {
            id: '1',
            name: 'Moduły',
            href: '/biznes/integracja/materialy-developerskie-moduly',
        },
        {
            id: '2',
            name: 'API',
            href: '/biznes/integracja/materialy-developerskie-api',
        },
        {
            id: '3',
            name: 'Karta produktu',
            href: '/biznes/integracja/komunikacja-stala-karta-produktu/',
        },
        {
            id: '4',
            name: 'Landing page',
            href: '/biznes/integracja/komunikacja-stala-landing-page/',
        },
        {
            id: '5',
            name: 'Logotypy',
            href: '/biznes/integracja/komunikacja-stala-logotyp/',
        },
    ];

export const INTEGRATION_SIDE_CONFIG: IntegrationSideContentTemplateProps = {
    listData: [
        {
            title: 'Materiały developerskie',
            id: '1',
            list: [
                {
                    id: '1',
                    name: 'Moduły',
                    Icon: CubeIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/biznes/integracja/materialy-developerskie-moduly',
                },
                {
                    id: '2',
                    name: 'API',
                    Icon: GearIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/biznes/integracja/materialy-developerskie-api',
                },
            ],
        },
        {
            title: 'Materiały marketingowe',
            id: '2',
            list: [
                {
                    id: '1',
                    name: 'Karta produktu',
                    Icon: CardsIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/biznes/integracja/komunikacja-stala-karta-produktu/',
                },
                {
                    id: '2',
                    name: 'Landing page',
                    Icon: BrowserIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/biznes/integracja/komunikacja-stala-landing-page/',
                },
                {
                    id: '3',
                    name: 'Logotypy',
                    Icon: ShapesIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/biznes/integracja/komunikacja-stala-logotyp/',
                },
            ],
        },
    ],
};
